import { COMMON_CONTENT } from './common';

export const AUTH_CONTENT = {
  login: {
    title: 'Welcome Back!',
    subtitle: 'Sign in to continue your cuddly journey',
    emailLabel: 'Email Address',
    emailPlaceholder: COMMON_CONTENT.placeholders.email,
    passwordLabel: 'Password',
    passwordPlaceholder: 'Enter your password',
    rememberMeLabel: 'Remember me',
    forgotPasswordLabel: 'Forgot password?',
    submitButton: 'Sign In',
    loadingText: 'Signing in...',
    dividerText: 'Or continue with',
    socialButtons: {
      google: 'Google',
      facebook: 'Facebook',
    },
    footerText: "Don't have an account?",
    footerLink: 'Create one',
    footerLinkPath: '/register',
  },
  register: {
    title: 'Create Account',
    subtitle: 'Join us for exclusive deals and cuddly finds!',
    nameLabel: 'Full Name',
    namePlaceholder: COMMON_CONTENT.placeholders.name,
    emailLabel: 'Email Address',
    emailPlaceholder: COMMON_CONTENT.placeholders.email,
    passwordLabel: 'Password',
    passwordPlaceholder: 'Create a password',
    confirmPasswordLabel: 'Confirm Password',
    confirmPasswordPlaceholder: 'Confirm your password',
    passwordHint: 'Must be at least 8 characters',
    termsPrefix: 'I agree to the',
    termsLink: 'Terms of Service',
    privacyPrefix: 'and',
    privacyLink: 'Privacy Policy',
    submitButton: 'Create Account',
    loadingText: 'Creating account...',
    dividerText: 'Or sign up with',
    socialButtons: {
      google: 'Google',
      facebook: 'Facebook',
    },
    footerText: 'Already have an account?',
    footerLink: 'Sign in',
    footerLinkPath: '/login',
  },
  forgotPassword: {
    title: 'Forgot Password?',
    subtitle: "We'll send you a link to reset your password",
    emailLabel: 'Email Address',
    emailPlaceholder: COMMON_CONTENT.placeholders.email,
    submitButton: 'Send Reset Link',
    loadingText: 'Sending...',
    successMessage: 'If an account exists, you will receive a reset link.',
    successTitle: 'Check Your Email',
    successSubtitle: "We've sent instructions to your inbox.",
  },
  resetPassword: {
    title: 'Reset Password',
    subtitle: 'Enter your new password below',
    newPasswordLabel: 'New Password',
    newPasswordPlaceholder: 'Enter new password',
    confirmPasswordLabel: 'Confirm Password',
    confirmPasswordPlaceholder: 'Confirm new password',
    submitButton: 'Update Password',
    loadingText: 'Updating...',
    success: {
      title: 'Password Reset!',
      subtitle: 'Your password has been updated.',
      description: 'You can now sign in with your new password.',
      buttonLabel: 'Go to Login',
    },
    invalid: {
      title: 'Invalid Link',
      subtitle: 'This reset link is invalid or expired.',
      description: 'Please request a new password reset link.',
      buttonLabel: 'Try Again',
    },
  },
  errors: {
    invalidEmail: 'Please enter a valid email.',
    userNotFound: 'User not found.',
    emailExists: 'Email already exists.',
    weakPassword: 'Password must be at least 8 characters.',
    passwordMismatch: 'Passwords do not match.',
    passwordsDoNotMatch: 'Passwords do not match.',
    invalidCredentials: 'Invalid email or password.',
    accountLocked: 'Too many failed attempts. Please try again later.',
    generic: 'Something went wrong. Please try again.',
    requiredField: (field: string) => `${field} is required.`,
  },
  layout: {
    sideTitle: 'Step into the world of BST - The Soft Studio',
    sideSubtitle: 'Find your next best friend among our handcrafted collection.',
    backToHome: 'Back to Home',
  },
} as const;

export const ACCOUNT_CONTENT = {
  title: 'My Account',
  breadcrumb: 'My Account',
  profile: {
    title: 'My Profile',
    subtitle: 'Manage your personal info and settings.',
    avatar: {
      title: 'Profile Picture',
      description: 'JPG or PNG. Max size 2MB. A good picture helps others recognize you.',
    },
    fields: {
      name: { label: 'Full Name', placeholder: 'Your Name' },
      email: { label: 'Email Address', placeholder: 'your@email.com' },
      phone: { label: 'Phone Number', placeholder: '+91' },
      address: { label: 'Primary Address', placeholder: 'Your address' },
    },
    saving: 'Saving Changes...',
  },
  orders: {
    title: 'My Orders',
    subtitle: 'Track your recent orders.',
    empty: {
      title: 'No Orders Yet',
      description: 'Start your collection today!',
      buttonLabel: 'Start Shopping',
    },
  },
  sidebar: {
    memberSince: (year: number) => `Member since ${year}`,
    menu: {
      profile: 'My Profile',
      orders: 'My Orders',
      wishlist: 'Wishlist',
      addresses: 'Addresses',
      payment: 'Payment Methods',
      notifications: 'Notifications',
    },
    logout: 'Sign Out',
    help: {
      title: 'Need Help?',
      description: 'Our support team is here for you 24/7 for any questions.',
      button: 'Contact Support',
    },
  },
  comingSoon: {
    title: (tab: string) => `${tab.charAt(0).toUpperCase() + tab.slice(1)} Coming Soon`,
    description: 'We are working hard to bring this feature to you!',
  },
  actions: {
    logout: 'Logout',
    editProfile: 'Edit Profile',
    saveProfile: 'Save Changes',
    cancel: 'Cancel',
  },
} as const;
